import { render } from "./GtrWin.vue?vue&type=template&id=b54b8adc&scoped=true&ts=true"
import script from "./GtrWin.vue?vue&type=script&lang=ts"
export * from "./GtrWin.vue?vue&type=script&lang=ts"

import "./GtrWin.vue?vue&type=style&index=0&id=b54b8adc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54b8adc"]])

export default __exports__